import {useGetAbsences} from './useGetAbsences'
import dayjs from 'dayjs'

export const useMissedAccessesCount = ({date, projectId}: {date?: Date; projectId?: string}) => {
    const isAvailable = !!date && !!projectId

    const {data: absences, isLoading} = useGetAbsences({
        params: {
            page: 1,
            limit: 99999,
            startDate: date ? dayjs(date).format('YYYY-MM-DD') : undefined,
            endDate: date ? dayjs(date).format('YYYY-MM-DD') : undefined,
            projectId
        },
        options: {
            enabled: isAvailable
        }
    })

    return {
        count: absences?.length ?? 0,
        isLoading,
        isAvailable: isAvailable && !isLoading
    }
}
